let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4ArgV")).then(() => parcelRequire('13H9y'));